import { FormattedMessage } from 'react-intl';

import { OrganizationJobPosition } from '@/shared/api/protocol-ts/model/dto_organization_job_position_pb';
import { OrganizationStaffRoleType } from '@/shared/api/protocol-ts/model/dto_organization_staff_pb';
import { MAX_NAME_LENGTH, MAX_EMAIL_LENGTH } from '@/shared/config';
import { object, string, number, array } from '@/shared/config/yup';

export type StaffFormPayload = {
  firstName: string;
  lastName: string;
  email: string;
  accessLevel: OrganizationStaffRoleType[];
  position: OrganizationJobPosition[];
};

export const getValidationSchema = (validateEmail: boolean) =>
  object({
    firstName: string().required().max(MAX_NAME_LENGTH),
    lastName: string().required().max(MAX_NAME_LENGTH),
    email: validateEmail
      ? string().email().required().max(MAX_EMAIL_LENGTH)
      : string().required().max(MAX_EMAIL_LENGTH),
    accessLevel: array()
      .of(number())
      .required()
      .min(1, () => (
        <FormattedMessage
          id="addStaffModal.accessLevelError"
          defaultMessage="accessLevel field must have at least 1 items"
        />
      ))
      .nullable(),
    position: array()
      .of(number())
      .required()
      .min(1, () => (
        <FormattedMessage
          id="addStaffModal.jobPositionError"
          defaultMessage="position field must have at least 1 items"
        />
      ))
      .nullable(),
  });
